import { classNames, isStatusFinished, isStatusRemoved } from '@library/utils';
import { PrizepicksSwitch } from '@library/components/switches';
import type { Status } from '@library/types/projection';

export interface ActiveSwitchProps {
  active: boolean;
  disabled?: boolean;
  isTableElement?: boolean;
  handleChange: (value: boolean) => void;
  statType: string;
  status?: Status;
}

export const ActiveSwitch = ({
  active,
  disabled = false,
  handleChange,
  isTableElement = true,
  statType,
  status = undefined
}: ActiveSwitchProps) => {
  return isTableElement ? (
    <td
      className={classNames(
        'py-4',
        isStatusRemoved(status) || isStatusFinished(status) ? 'opacity-50' : ''
      )}
      key={`${statType}-switch`}
    >
      <PrizepicksSwitch
        active={active}
        disabled={disabled}
        handleChange={handleChange}
        statType={statType}
      />
    </td>
  ) : (
    <div
      className={classNames(
        'py-4',
        isStatusRemoved(status) || isStatusFinished(status) ? 'opacity-50' : ''
      )}
      key={`${statType}-switch`}
    >
      <PrizepicksSwitch
        active={active}
        disabled={disabled}
        handleChange={handleChange}
        statType={statType}
      />
    </div>
  );
};
